var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "c--about-us_founder-detail new-container mx-auto"
  }, [_c('div', {
    staticClass: "founder-detail-container"
  }, [_c('div', {
    staticClass: "founder-detail"
  }, [_c('div', {
    staticClass: "founder-detail-item"
  }, [_c('div', {
    staticClass: "founder-detail-item-image"
  }, [_c('img', {
    directives: [{
      name: "lazy-load",
      rawName: "v-lazy-load"
    }],
    attrs: {
      "data-src": _vm.info.img,
      "src": "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
      "width": "445",
      "height": "455",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "founder-detail-item-text"
  }, [_c('h1', {
    staticClass: "founder-detail-name"
  }, [_vm._v(_vm._s(_vm.info.name))]), _vm._v(" "), _c('h2', {
    staticClass: "founder-detail-title"
  }, [_vm._v(_vm._s(_vm.info.title))]), _vm._v(" "), _c('div', {
    staticClass: "founder-detail-description",
    domProps: {
      "innerHTML": _vm._s(_vm.info.description)
    }
  })])])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }